import React, { useState } from "react";
import Highlighter from "react-highlight-words";

import { useDispatch } from "react-redux";
// import QiwaPopUp from "../QiwaPopUp";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import QiwaPopUp_ops from "../../QiwaPopUp";

export default function ListQiwaContract_OPS({
  titles = [],
  list = [],
  updateData,
}) {
  const [listData, setListData] = useState({});
  const [Popup, setPopUp] = useState(false);

  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <Search
            searchKey={[
              "employee_id",
              "visa_reference_number",
              "border_number",
            ]}
            setSearchWords={setSearchWords}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-qiwa-contract auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}

          {!list?.isLoading
            ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.religion || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.current_sponsor || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>{list.uploaded_count}</p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.qiwa_contract_status || "-"}
                    />
                  </p>

                  <button
                    className={
                      "p-1 px-2 rounded-md  bg-red text-white text-xs p-2 w-20"
                    }
                    onClick={() => {
                      setPopUp(true);
                      setListData(list);
                    }}
                    disabled={
                      list.qiwa_contract_status === "Active"
                    }
                  >
                    VIEW DETAILS
                  </button>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
            : ""}
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <QiwaPopUp_ops
          PopUp={Popup}
          setPopUp={setPopUp}
          title={""}
          data={listData}
          updateApi={updateData}
        />
      ) : (
        ""
      )}
    </>
  );
}
